import {
  SET_INITIAL_GLOBAL_PRICE_MODAL_STATE,
  SET_GLOBAL_PRICE_LOADING_STATE,
  SET_GLOBAL_PRICE_MODAL_STATE,
  UPDATE_GLOBAL_PRICE_ASYNC_ERROR,
  RESET_GLOBAL_PRICING_STATE,
  SET_PRICE_OUTDATED_WARNING_STATE,
  SET_AFTER_PRICE_OUTDATED_WARNING_STATE
} from 'actions/globalPrice';

const initialState = {
  isLoading: false,
  isError: false,
  message: '',
  isInitialModalOpen: true,
  isModalOpen: false,
  isPriceOutdatedWarning: false,
  isAfterPriceOutdatedWarning: false,
  data: {},
};

const actionsMap = {
  [SET_INITIAL_GLOBAL_PRICE_MODAL_STATE]: (state, action) => {
    return {
      ...state,
      isInitialModalOpen: action.payload,
    };
  },
  [SET_GLOBAL_PRICE_LOADING_STATE]: (state, action) => {
    return {
      ...state,
      isLoading: action.payload,
    };
  },
  [SET_GLOBAL_PRICE_MODAL_STATE]: (state, action) => {
    return {
      ...state,
      isModalOpen: action.payload,
    };
  },
  [UPDATE_GLOBAL_PRICE_ASYNC_ERROR]: (state, action) => {
    return {
      ...state,
      isError: true,
      message: action.payload,
    };
  },
  [SET_PRICE_OUTDATED_WARNING_STATE]: (state, action) => {
    return {
      ...state,
      isPriceOutdatedWarning: action.payload,
    };
  },
  [SET_AFTER_PRICE_OUTDATED_WARNING_STATE]: (state, action) => {
    return {
      ...state,
      isAfterPriceOutdatedWarning: action.payload,
    };
  },
  [RESET_GLOBAL_PRICING_STATE]: () => initialState,
};

export default function globalPrice(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
